// Mock data for Trademark Credentials website

export const testimonials = [
  {
    id: 1,
    name: "David Harrison",
    company: "Harrison Enterprises",
    text: "Trademark Credentials made the trademark registration process incredibly smooth. Their team was professional, responsive, and guided us through every step. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Jennifer Martinez",
    company: "Martinez Consulting Group",
    text: "Outstanding service! They handled our trademark registration efficiently and kept us informed throughout the process. The comprehensive search report was thorough and valuable.",
    rating: 5
  },
  {
    id: 3,
    name: "Robert Chang",
    company: "Chang Industries",
    text: "Professional, knowledgeable, and efficient. Trademark Credentials protected our brand identity seamlessly. Their dedicated case manager was always available to answer questions.",
    rating: 5
  },
  {
    id: 4,
    name: "Lisa Thompson",
    company: "Thompson Global",
    text: "Excellent experience from start to finish. The team at Trademark Credentials is truly expert in trademark law. They saved us time and gave us peace of mind.",
    rating: 5
  },
  {
    id: 5,
    name: "Christopher Davis",
    company: "Davis & Associates",
    text: "I was impressed by their attention to detail and commitment to protecting our trademark. Fast, reliable, and professional service. Worth every penny!",
    rating: 5
  },
  {
    id: 6,
    name: "Amanda Wilson",
    company: "Wilson Brands",
    text: "Exceptional service and expertise! The team guided us through complex trademark issues with ease. Their professionalism exceeded our expectations.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Consultation & Search",
    description: "We review your trademark and conduct a comprehensive search to ensure availability and reduce the risk of rejection.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Application Filing",
    description: "Our experts prepare and file your trademark application with the USPTO, ensuring all documentation is accurate and complete.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Monitoring & Protection",
    description: "We monitor your trademark status and provide ongoing support to protect your brand and intellectual property rights.",
    icon: "Shield"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic",
    price: "$349",
    fee: "+ Upto Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee"
    ],
    note: "(Govt. filing fee not included)",
    recommended: false
  },
  {
    id: 2,
    name: "Standard",
    price: "$399",
    fee: "+ Upto Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee",
      "Refusal Risk Meter"
    ],
    note: "(Govt. filing fee not included)",
    recommended: false
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$499",
    fee: "+ Upto Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "(Govt. filing fee not included)",
    recommended: true
  },
  {
    id: 4,
    name: "Platinum",
    price: "$549",
    fee: "+ Upto Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "100% Approval Guarantee",
      "Comprehensive Trademark Search Report (Federal & State)",
      "24 Hrs. Expedited Service",
      "Cease & Desist Letter"
    ],
    note: "(Govt. filing fee not included)",
    recommended: false
  }
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    slug: "trademark-registration",
    description: "Protect your brand identity with comprehensive trademark registration services.",
    icon: "Award",
    category: "trademark",
    hero_image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
    detail_image: "https://images.unsplash.com/photo-1603796846097-bee99e4a601f",
    benefits: [
      { icon: "Shield", title: "Brand Protection", description: "Secure exclusive rights to your brand name and logo nationwide" },
      { icon: "Scale", title: "Legal Rights", description: "Gain legal standing to prevent others from using similar marks" },
      { icon: "TrendingUp", title: "Business Value", description: "Increase your company's valuation with registered IP assets" },
      { icon: "CheckCircle", title: "USPTO Filing", description: "Expert handling of all federal trademark applications" }
    ],
    process: [
      { title: "Trademark Search", description: "We conduct comprehensive searches to ensure your mark is available and minimize rejection risks." },
      { title: "Application Preparation", description: "Our attorneys prepare and file your application with precise classification and documentation." },
      { title: "Office Action Response", description: "We handle any USPTO correspondence and guide your mark to successful registration." }
    ]
  },
  {
    id: 2,
    title: "Copyright Registration",
    slug: "copyright-registration",
    description: "Secure legal protection for your original creative works and content.",
    icon: "Book",
    category: "copyright",
    hero_image: "https://images.unsplash.com/photo-1595002435321-133ac0aee0bc",
    detail_image: "https://images.unsplash.com/photo-1580127645995-d43fe9598711",
    benefits: [
      { icon: "FileText", title: "Creative Protection", description: "Protect your original works including writing, music, art, and software" },
      { icon: "Scale", title: "Legal Evidence", description: "Establish public record of ownership for your creative works" },
      { icon: "DollarSign", title: "Statutory Damages", description: "Qualify for statutory damages and attorney fees in infringement cases" },
      { icon: "Globe", title: "International Rights", description: "Gain protection under international copyright treaties" }
    ],
    process: [
      { title: "Work Review", description: "We review your creative work to determine copyrightability and proper registration classification." },
      { title: "Application Filing", description: "Complete preparation and submission of your copyright application to the U.S. Copyright Office." },
      { title: "Certificate Delivery", description: "Receive your official copyright registration certificate upon approval." }
    ]
  },
  {
    id: 3,
    title: "Trademark Comprehensive Search",
    slug: "trademark-search",
    description: "Thorough trademark search to identify potential conflicts before filing.",
    icon: "Search",
    category: "trademark",
    hero_image: "https://images.unsplash.com/photo-1741795746033-d50d48dc1da5",
    detail_image: "https://images.unsplash.com/photo-1721046013656-0a0980264689",
    benefits: [
      { icon: "Search", title: "Comprehensive Analysis", description: "Search federal, state, and common law databases for potential conflicts" },
      { icon: "BarChart", title: "Risk Assessment", description: "Detailed analysis of trademark availability and registration likelihood" },
      { icon: "FileText", title: "Detailed Report", description: "Receive comprehensive written report with findings and recommendations" },
      { icon: "Clock", title: "Save Time & Money", description: "Avoid costly application fees and delays from preventable rejections" }
    ],
    process: [
      { title: "Database Search", description: "We search USPTO records, state registrations, and common law sources for similar marks." },
      { title: "Analysis & Review", description: "Our attorneys analyze search results to assess potential conflicts and risks." },
      { title: "Report Delivery", description: "Receive detailed report with clearance recommendations and strategic guidance." }
    ]
  },
  {
    id: 4,
    title: "Company Formation",
    slug: "company-formation",
    description: "Professional assistance with business entity formation and registration.",
    icon: "Building",
    category: "business",
    hero_image: "https://images.pexels.com/photos/7310202/pexels-photo-7310202.jpeg",
    detail_image: "https://images.pexels.com/photos/7309483/pexels-photo-7309483.jpeg",
    benefits: [
      { icon: "Building", title: "Entity Formation", description: "LLC, Corporation, or Partnership - choose the right structure for your business" },
      { icon: "Shield", title: "Liability Protection", description: "Separate your personal assets from business liabilities" },
      { icon: "FileText", title: "Complete Filing", description: "Handle all state filing requirements and documentation" },
      { icon: "Users", title: "Expert Guidance", description: "Professional advice on entity selection and compliance requirements" }
    ],
    process: [
      { title: "Entity Selection", description: "Consultation to determine the best business structure for your needs and goals." },
      { title: "Document Preparation", description: "Prepare articles of incorporation/organization and all required state filings." },
      { title: "State Filing & Setup", description: "File with state authorities and obtain your EIN and corporate documents." }
    ]
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    slug: "amazon-brand-registry",
    description: "Protect and manage your brand on Amazon's marketplace platform.",
    icon: "ShoppingCart",
    category: "ecommerce",
    hero_image: "https://images.pexels.com/photos/12820603/pexels-photo-12820603.jpeg",
    detail_image: "https://images.pexels.com/photos/4560039/pexels-photo-4560039.jpeg",
    benefits: [
      { icon: "ShoppingCart", title: "Brand Control", description: "Gain powerful tools to protect and manage your brand on Amazon" },
      { icon: "Shield", title: "Counterfeit Protection", description: "Proactive brand protection against unauthorized sellers and counterfeiters" },
      { icon: "BarChart", title: "Enhanced Content", description: "Access to A+ Content and enhanced brand store capabilities" },
      { icon: "Search", title: "Search Priority", description: "Improved search visibility and brand analytics on Amazon" }
    ],
    process: [
      { title: "Trademark Verification", description: "Ensure your trademark is registered or pending with the USPTO for Amazon eligibility." },
      { title: "Brand Registry Setup", description: "Complete Amazon Brand Registry enrollment with your registered trademark." },
      { title: "Brand Protection Activation", description: "Activate brand protection tools and enhanced selling features on Amazon." }
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does the trademark registration process take?",
    answer: "The trademark registration process typically takes 8-12 months from filing to registration, depending on the complexity of your application and USPTO workload."
  },
  {
    id: 2,
    question: "What is included in a trademark search?",
    answer: "Our comprehensive trademark search includes reviewing federal and state databases, common law trademarks, domain names, and social media platforms to identify potential conflicts."
  },
  {
    id: 3,
    question: "Can I trademark a logo and business name together?",
    answer: "Yes, you can file a combined trademark application that includes both your logo and business name, or file them separately for broader protection."
  },
  {
    id: 4,
    question: "What are the government filing fees?",
    answer: "USPTO filing fees range from $250-$350 per class of goods/services. Our service fees are separate from these government fees."
  },
  {
    id: 5,
    question: "Do you offer refunds if my trademark is rejected?",
    answer: "While we cannot guarantee approval, we thoroughly research and prepare your application to maximize success. Contact us to discuss our specific refund policy."
  }
];

export const benefits = [
  {
    id: 1,
    title: "Expert Guidance",
    description: "Our trademark attorneys have years of experience navigating the USPTO process.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Fast Processing",
    description: "We file your application quickly and efficiently to establish your priority date.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Comprehensive Protection",
    description: "We ensure your trademark is properly protected across all relevant classes.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Ongoing Support",
    description: "Dedicated case managers provide updates and support throughout the process.",
    icon: "Headphones"
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada", countryCode: "US" },
  { code: "+44", country: "UK", countryCode: "GB" },
  { code: "+91", country: "India", countryCode: "IN" },
  { code: "+61", country: "Australia", countryCode: "AU" },
  { code: "+81", country: "Japan", countryCode: "JP" },
  { code: "+86", country: "China", countryCode: "CN" },
  { code: "+49", country: "Germany", countryCode: "DE" },
  { code: "+33", country: "France", countryCode: "FR" },
  { code: "+39", country: "Italy", countryCode: "IT" },
  { code: "+34", country: "Spain", countryCode: "ES" },
  { code: "+31", country: "Netherlands", countryCode: "NL" },
  { code: "+92", country: "Pakistan", countryCode: "PK" },
  { code: "+971", country: "UAE", countryCode: "AE" },
  { code: "+966", country: "Saudi Arabia", countryCode: "SA" }
];
